import { render, staticRenderFns } from "./wizard-stepper.vue?vue&type=template&id=274e663e&"
import script from "./wizard-stepper.vue?vue&type=script&lang=js&"
export * from "./wizard-stepper.vue?vue&type=script&lang=js&"
import style0 from "./wizard-stepper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports